import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ImpuestoRetenerTarifa = {

    async Get() { return await methods.Get("ImpuestoRetenerTarifa/Get") },
    async GetConfigIva() { return await methods.Get("ImpuestoRetenerTarifa/GetConfigIva") },

   // async Get() { return await methods.Get("LiquidacionCompraDetalleTemp/Get" ) },
    async Post(data) { return await methods.Post("ImpuestoRetenerTarifa/Post", data) },
    async Put(qs, data) { return await methods.Put("ImpuestoRetenerTarifa/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ImpuestoRetenerTarifa/Delete" + useParamsJson(qs)) }
};

export default ImpuestoRetenerTarifa;